module.exports = __webpack_public_path__ + "static/img/1.ca3ac71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/05/1.png
// module id = r00g
// module chunks = 1